import { render } from "./ServersTable.vue?vue&type=template&id=5a51ddf9&ts=true"
import script from "./ServersTable.vue?vue&type=script&lang=ts"
export * from "./ServersTable.vue?vue&type=script&lang=ts"

import "./ServersTable.vue?vue&type=style&index=0&id=5a51ddf9&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__